import {FileListEntity} from "./types";

export const pathToFilename = (file: FileListEntity) => {
    const {path} = file;
    const parts = path.split("/").filter(part => !!part);
    return parts[parts.length - 1];
};
